module.exports = __webpack_public_path__ + "static/img/zigBee.dedbaa2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zigBee.png
// module id = dnG+
// module chunks = 9